import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination, Spinner } from '@/components/ui'
import apiFetch from '@/services/apiService'

import { addFlashMessage } from '@/features/flash/flashMessagesSlice'

import DocumentItem from '../common/DocumentItem'

const TYPE_DOCUMENT = "decompte"
 
export default () => {
  const dispatch = useDispatch()
  const contact = useSelector( state => state.auth.profile)

  // États pour gérer les documents
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0
  })
  const [filters, setFilters] = useState({
    page: 1,
    limit: 15,
    type_document: TYPE_DOCUMENT
  })
  
  // Fonction pour charger les documents
  const fetchDocuments = async () => {
    if (!contact?.id) return
    
    setLoading(true)
    try {
      const response = await apiFetch()
        .url(`contacts/${contact.id}/documents`)
        .query(filters)
        .get()
      
      setDocuments(response.documents || [])
      setPagination({
        currentPage: response.current_page || 1,
        totalPages: response.total_pages || 1,
        totalCount: response.total_count || 0
      })
    } catch (error) {
      console.error(`Erreur lors du chargement des documents de type ${type}:`, error)
      dispatch(addFlashMessage({
        type: 'error',
        text: `Erreur lors du chargement des documents de type ${type}`
      }))
    } finally {
      setLoading(false)
    }
  }

  // useEffect qui gère le chargement initial 
  // Chargement initial quand bien.id est disponible et documents est vide
  useEffect(
    () => {
      fetchDocuments()
    },
    [filters]
  ) 
  
  const handlePageChange = (page) => {
    // Mettre à jour les filtres avec la nouvelle page
    setFilters({ ...filters, page })
  }

  return (
    <div className="overflow-hidden mb-4">
      <h3 className="text-lg font-semibold mb-4 px-4 pt-4">
        Vos documents comptables 
      </h3>
      <div className="bg-primary-100 p-4 rounded-none h-full"> 
        { loading && <Spinner /> }
        { !loading && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"> 
            { documents.length == 0 ? 
              <p className="col-span-2 text-center">Aucun décompte</p> :
              <>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(0, Math.ceil(documents.length/3)).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(Math.ceil(documents.length/3), Math.ceil(documents.length/3)*2).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(Math.ceil(documents.length/3)*2).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
              </>
            }
        </div> }
        { pagination && pagination.totalPages > 1 && 
          <Pagination 
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        }
      </div>
    </div>
  )
}